import { Checkbox, Hidden, ScreenClass, ScreenClassRender, Strong } from 'main/ui'
import { IFilters } from 'main/util/search'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../../common'
import { i18nKeyPrefix } from '../../../../i18n'
import { CheckboxGroupContainer, FieldCopyContainer, FieldsContainer } from '../common'

interface IFieldsProps {
  params: IFilters
  onChangeParams: (params: IFilters) => void
}

const PRE = `${i18nKeyPrefix}-FILTERS-AVAILABILITY-FORM-FIELDS`

export function Fields(fieldsProps: IFieldsProps) {
  const { params, onChangeParams } = fieldsProps
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <div>
      <Hidden lg xl>
        <FieldCopyContainer>
          <Strong>{t(`${PRE}-STRONG`)}</Strong>
        </FieldCopyContainer>
      </Hidden>
      <FieldsContainer>
        <CheckboxGroupContainer>
          <ScreenClassRender
            render={(screenClass: ScreenClass) => (
              <Checkbox
                data-pendo="availabilityFilter-isOpen"
                checked={params.hasAvailability ? params.hasAvailability : false}
                label={
                  ['lg', 'xl'].includes(screenClass) ? t(`${PRE}-LABEL`) : t(`${PRE}-LABEL-MOBILE`)
                }
                onChange={checked => onChangeParams({ ...params, hasAvailability: checked })}
              />
            )}
          />
        </CheckboxGroupContainer>
      </FieldsContainer>
    </div>
  )
}
